import React from 'react';
import styled from 'styled-components';

import { Medium, Bold, SemiBold } from './Text';

import { FONT } from '../../styles/color';
import { SHIPPING_FEE } from '../../utils/constants';

const Container = styled.div`
    width: 100%;
    height: 340px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 40px 30px;
    border: 1px solid ${ FONT.mid };
    border-radius: 12px;
    box-sizing: border-box;
    gap: 30px;
`;

const InfoWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const LineWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const DecoLine = styled.div`
    width: 100%;
    height: 3px;
    background-color: ${ FONT.default };
`;

const NextButton = styled.button`
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 70px;
    background-color: ${ FONT.default };
    border: none;
    border-radius: 0px 0px 12px 12px;
`;

export default function Calculator(props) {
    const productsPrice = props.items.reduce(
        (acc, current, index) => {
            if(props.selectedItems[index]) {
                acc += (current.price * current.quantity)
            }
            return acc;
        },
        0
    );

    const shippingCost = props.items.reduce(
        (acc, current, index) => {
            if(props.selectedItems[index]) {
                acc += (SHIPPING_FEE * current.quantity)
            }
            return acc;
        },
        0
    );

    return (
        <Container>
            <SemiBold size="24px" style={{ width: '100%' }}>{ props.title }</SemiBold>
            <InfoWrapper>
                <LineWrapper>
                    <Medium size="18px" color={ FONT.deep01 }>상품 금액</Medium>
                    <Medium size="18px">{ productsPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원
                    </Medium>
                </LineWrapper>
                <LineWrapper>
                    <Medium size="18px" color={ FONT.deep01 }>배송비</Medium>
                    <Medium size="18px">{ shippingCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원
                    </Medium>
                </LineWrapper>
                <DecoLine />
                <LineWrapper>
                    <SemiBold size="18px">총 주문금액</SemiBold>
                    <SemiBold size="18px">{ (productsPrice + shippingCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원
                    </SemiBold>
                </LineWrapper>
            </InfoWrapper>
            <NextButton onClick={ () => props.onClickOrder(productsPrice, shippingCost) }>
                <Bold size="20px" color={ FONT.light01 }>주문하기</Bold>
            </NextButton>
        </Container>
    );
}